export default __webpack_public_path__ + "static/media/skovstykket-tenancy-02.7cbbb731.jpg";